// Shared auth-aware helpers for timeline file attachments.
import { useState, useEffect } from "react";
import { api } from "@/lib/api";

export const AuthImg = ({ fileId, alt }) => {
  const [src, setSrc] = useState(null);
  useEffect(() => {
    let url;
    api.get(`/timeline/files/${fileId}/thumbnail`, { responseType: "blob" })
      .then((res) => { url = URL.createObjectURL(res.data); setSrc(url); })
      .catch(() => {});
    return () => { if (url) URL.revokeObjectURL(url); };
  }, [fileId]);
  if (!src) return <div className="w-full h-full bg-slate-100 animate-pulse" />;
  return <img src={src} alt={alt} className="w-full h-full object-cover" />;
};

export const openTimelineFile = async (id) => {
  try {
    const res = await api.get(`/timeline/files/${id}/download`, { responseType: "blob" });
    const url = URL.createObjectURL(res.data);
    window.open(url, "_blank");
    setTimeout(() => URL.revokeObjectURL(url), 60000);
  } catch { /* view-only — fail quietly */ }
};
